export default {
  // App Bar Actions
  app_bar_actions: {
    account_menu: {
      tooltip: "Account Details",

      // Account Menu Card
      account_menu_card: {
        // Language Section
        language_section: {
          title: "Choose Language",
          tooltip: "Select your preferred language",

          languages: {
            en: "English",
            bg: "Bulgarian",
            mk: "Macedonian",
          },
        },

        // Theme Section
        theme_section: {
          title: "Choose Theme",
          tooltip: "Select application theme",

          themes: {
            light: "Light",
            dark: "Dark",
            auto: "System",
          },
        },

        // Sign Out
        sign_out: {
          title: "Sign out",
          tooltip: "Sign out of the application",
        },
      },
    },
  },

  // Drawer Toggle
  drawer_toggle: {
    open_tooltip: "Open Menu",
    rail_tooltip: "Expand Menu",
    close_tooltip: "Close Menu",
  },

  // Page Titles
  page_titles: {
    channels: "Channels",
    instruments: "Instruments",
    locations: "Locations",
    validation: "Validation",
    tests: "Tests",
    about: "About",
    login: "Login",
  },
};
